import { Injectable } from '@angular/core';
import { BehaviorSubject, delay, finalize } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateGlobalGeofenceCommand } from '../contract/create-global-geofence-command.contract';
import { DeleteGlobalGeofenceCommand } from '../contract/delete-global-geofence-command.contract copy';
import { ViewGlobalGeofence } from '../contract/view-global-geofence.contract';
import { GlobalGeofenceApiService } from './global-geofence-api.service.ts';

@Injectable({ providedIn: 'root' })
export class GlobalGeofencesDataSource {
  private _loading$ = new BehaviorSubject(false);
  private _geofences$ = new BehaviorSubject<ViewGlobalGeofence[]>([]);

  public readonly loading$ = this._loading$.asObservable();
  public readonly geofences$ = this._geofences$.asObservable();

  constructor(private _globalGeofencesService: GlobalGeofenceApiService) { }

  getGlobalGeofences(): void {
    this._loading$.next(true);
    this._globalGeofencesService
      .getGlobalGeofences()
      .pipe(finalize(() => this._loading$.next(false)))
      .subscribe((res: ViewGlobalGeofence[]) => this._geofences$.next(res));
  }

  resetGlobalGeofences(): void {
    this._geofences$.next([]);
  }

  createGlobalGeofence(cmd: CreateGlobalGeofenceCommand): void {
    this._loading$.next(true);
    this._globalGeofencesService
      .createGlobalGeofence(cmd)
      .pipe(delay(environment.DELAY_SHORT))
      .pipe(finalize(() => this._loading$.next(false)))
      .subscribe(() => this.getGlobalGeofences());
  }

  deleteGlobalGeofence(cmd: DeleteGlobalGeofenceCommand): void {
    this._loading$.next(true);
    this._globalGeofencesService
      .deleteGlobalGeofence(cmd)
      .pipe(delay(environment.DELAY_SHORT))
      .pipe(finalize(() => this._loading$.next(false)))
      .subscribe(() => this.getGlobalGeofences());
  }
}
